import { useContext } from "react";
import { AdminModalLoadingContext } from "libs/context/AdminModalLoadingContext";

function useAdminModalLoading() {
  return useContext(AdminModalLoadingContext);
}

export default useAdminModalLoading;
